import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=7c58bf65&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=7c58bf65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c58bf65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c58bf65')) {
      api.createRecord('7c58bf65', component.options)
    } else {
      api.reload('7c58bf65', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=7c58bf65&scoped=true&", function () {
      api.rerender('7c58bf65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/Logo.vue"
export default component.exports